import { createReducer, on } from '@ngrx/store';
import { Company } from '../../shared/models/company.model';
import { CompanyInvestorDto, CompanyInvestorStatsDto } from '../../shared/models/dtos/company-investor.dto';
import { User } from '../../shared/models/user.model';
import { GenericList, DefaultGenericList } from '../shared/models/generic-list.model';
import { mergeItemInList } from '../shared/utils/functions';
import {
  loadInvestorCompany,
  loadInvestorCompanyStatsSuccess,
  loadInvestorCompanySuccess,
  loadInvestors,
  loadInvestorsFail,
  loadInvestorsSuccess,
  loadInvestorUser,
  loadInvestorUserSuccess,
  setInvestorItemActiveSuccess,
  setInvestorItemBusinessConsultantSuccess,
  updateInvestorCompanyClientSuccess,
  clearInvestors,
} from './investors.actions';

export interface InvestorsState {
  loading?: boolean;
  list?: GenericList<CompanyInvestorDto>;
  total: number;
  totalPages: number;
  companiesStats: CompanyInvestorStatsDto[];
  companiesList?: Company[];
  usersList: User[];
}

const initialState: InvestorsState = {
  loading: false,
  list: DefaultGenericList<CompanyInvestorDto>(),
  total: 0,
  totalPages: 0,
  companiesStats: [],
  companiesList: [],
  usersList: [],
};

export const investorsReducer = createReducer(
  initialState,
  on(loadInvestors, (state) => ({
    ...state,
    loading: true,
  })),
  on(loadInvestorsFail, (state) => ({
    ...state,
    loading: false,
    list: { ...state.list, items: [] },
    total: 0,
    totalPages: 0,
  })),
  on(loadInvestorsSuccess, (state, action) => ({
    ...state,
    loading: false,
    total: action.payload.total,
    totalPages: action.payload.totalPages ?? 0,
    list: {
      ...state.list,
      items: action.payload.list,
    },
  })),
  on(setInvestorItemActiveSuccess, (state, action) => {
    const items = [...state.list.items];
    const index = items.findIndex(i => i.companyId === action.payload.id);
    if (index >= 0) {
      items[index] = { ...items[index], companyIsActive: action.payload.isActive };
    }
    return { ...state, list: { ...state.list, items } };
  }),
  on(setInvestorItemBusinessConsultantSuccess, (state, action) => {
    const { company } = action.payload;
    return {
      ...state,
      list: {
        ...state.list,
        items: state.list.items.map(item => item.companyId === company.id
          ? { ...item, businessConsultant: company.businessConsultant }
          : item),
      },
    };
  }),
  on(updateInvestorCompanyClientSuccess, (state, action) => {
    const { company } = action.payload;
    return {
      ...state,
      list: {
        ...state.list,
        items: state.list.items.map(item => item.companyId === company.id ?
          { ...item, clientActivationDate: company.clientActivationDate } : item),
      },
    };
  }),
  on(loadInvestorCompanyStatsSuccess, (state, action) => ({
    ...state,
    companiesStats: [...state.companiesStats, action.payload.stats],
  })),
  on(loadInvestorCompany, (state) => ({ ...state, loading: true })),
  on(loadInvestorCompanySuccess, (state, action) => ({
    ...state,
    loading: false,
    companiesList: mergeItemInList(state.companiesList, action.payload.company),
  })),
  on(loadInvestorUser, (state) => ({ ...state, loading: true })),
  on(loadInvestorUserSuccess, (state, action) => ({
    ...state,
    loading: false,
    usersList: mergeItemInList(state.usersList, action.payload.user),
  })),
  on(clearInvestors, () => initialState),
);
